import FamilyEvent from "./ResponsiveEvent.jsx/FamilyEvent"
import useFormContext from "./ResponsiveEvent.jsx/useFormContext"
import ScheduleRequestor from "./ResponsiveEvent.jsx/ScheduleRequestor"
import Guests from "./ResponsiveEvent.jsx/Guests"
import FamilySummaryRequestor from "./ResponsiveEvent.jsx/FamilySummaryRequestor"
import History from "./ResponsiveEvent.jsx/History"

const FamilyFormInputs = () => {

    const { page } = useFormContext()

    const display = {
        0: <FamilyEvent />,
        1: <ScheduleRequestor familyMode="false" />,
        2: <Guests />,
        3: <History familyMode="false" />,
        4: <FamilySummaryRequestor familyMode="false" />
    }

    const content = (
        <>
            {display[page]}
        </>
    )


    return content
}
export default FamilyFormInputs